import { Component, OnInit } from '@angular/core';
import {EventsService} from '../../../events.service';
import {GlobalService} from '../../../../global.service';
@Component({
  selector: 'app-participants',
  templateUrl: './participants.component.html',
  styleUrls: ['./participants.component.css']
})
export class ParticipantsComponent implements OnInit {
  language: any;
  langChosen = 'en';
  constructor(public eventService: EventsService, public globalService: GlobalService) {
    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.language = require('../lang/' + localStorage.getItem('language') + '.json');
        this.langChosen = localStorage.getItem('language');
      } else {
        this.language = require('../lang/en.json');
      }
    }

  }

  ngOnInit() {
  }

}
